import InputField from "../../atoms/InputField";
import SubHeading from "../../atoms/SubHeading";

const DocumentacionSection = ({ setFieldValue, setArchivosPermanentes }) => {
    const fields = [
        { name: "escritura", label: "Escritura" },
        { name: "comprobante_domicilio", label: "Comprobante de domicilio" },
        { name: "predial", label: "Predial" },
        { name: "contrato_luz", label: "Luz" },
        { name: "contrato_agua", label: "Agua" },
        { name: "seguro", label: "Seguro (opcional)" },
    ];

    return (
        <div className="w-full flex flex-col border border-gray-500 bg-gray-100 p-4 rounded-md">
            <SubHeading text="Documentación" color="black" />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 rounded-md">
                {fields.map(({ name, label }) => (
                <InputField
                    key={name}
                    name={name}
                    label={label}
                    type="file"
                    onChange={(e) => {
                    const file = e.currentTarget.files?.[0] || null;
                    setFieldValue(name, file);
                    setArchivosPermanentes((prev) => ({ ...prev, [name]: file }));
                    }}
                />
                ))}
            </div>
        </div>
    );
};

export default DocumentacionSection;